import api from "../index";

export const GetAllKycApi = (params) => api.get(`Admin/GetAll-UserKyc?${params}`);
export const ExportUserKycApi = (params) =>
  api.get(`Admin/Export-UserKyc?${params}`, {
    responseType: "blob",
    headers: {
      Accept: "*/*",
    },
  });
export const GetAllKycByIdApi = (kycId) => api.get(`Admin/GetSingleKYC/${kycId}`);
export const KycRequestAcceptRejectApi = (data) => api.post('Admin/UserRejected-ApprovedKyc', data);

export const UploadDocumentApi = (data, headers) => api.post('UserAddKyc/Upload-Document', data, headers);
export const ReuploadKycDocumentApi = (data, headers) => api.post('Admin/Reupload-KYC-Document', data, headers);
